import React from "react";
import axios from "axios";
import * as Icon from "react-feather";
import { useHistory } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { useAppRegistryStore } from "../../../stores/appRegistryStore";
import { useTranslation } from 'react-i18next';
import "./Campaigns.css";

const Campaigns = (props) => {
  const history = useHistory();
  const url = process.env.REACT_APP_BASEURL;
  const { settings } = useAppRegistryStore();
  const isDarkMode = settings.currentTheme === "dark";
  const { t } = useTranslation('common');
  
  const [campaigns, setCampaigns] = React.useState([]);
  const [msgData, setMsgData] = React.useState(null);
  const [selectedCampaign, setSelectedCampaign] = React.useState(null);
  const [isEditing, setIsEditing] = React.useState(false);
  // ✅ Campaña sin prueba: solo descuento (trialDays = 0)
  const [isNoTrialCampaign, setIsNoTrialCampaign] = React.useState(false);
  const [trialDaysValue, setTrialDaysValue] = React.useState(14);
  
  // Estados para Dialog de confirmación
  const [confirmDialog, setConfirmDialog] = React.useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  
  // Estados para Snackbar
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "info", // success, error, warning, info
  });

  // ✅ NUEVO: Función para actualizar mensaje de descuento
  const updateDiscountMessage = (discountValue, discountType) => {
    const messageDiv = document.getElementById("discount-info-message");
    if (!messageDiv) return;
    
    const value = parseFloat(discountValue);
    if (isNaN(value)) {
      messageDiv.style.display = 'none';
      return;
    }
    
    // Mostrar mensaje según el tipo y valor
    if (discountType === "percentage") {
      if (value === 100) {
        // ✅ Trial gratis (100%)
        messageDiv.innerHTML = `
          <div class="alert alert-success" role="alert">
            <strong>🎉 Trial Gratis:</strong> 
            Con 100% de descuento, los usuarios obtendrán un trial completamente gratuito por el número de días configurado (trialDays).
            <strong>No se requerirá pago.</strong>
          </div>
        `;
        messageDiv.style.display = 'block';
      } else if (value < 100 && value > 0) {
        // ✅ Descuento de campaña (<100%)
        messageDiv.innerHTML = `
          <div class="alert alert-info" role="alert">
            <strong>💰 Descuento de Campaña:</strong> 
            Con ${value}% de descuento, los usuarios deberán:
            <ol style="margin-bottom: 0; padding-left: 20px;">
              <li>Completar formulario de registro</li>
              <li>Seleccionar plan y número de licencias en la página de Precios</li>
              <li>Ver comparación de precio normal vs precio con descuento</li>
              <li>Pagar el precio descontado:
                <ul style="margin-top: 5px; margin-bottom: 0;">
                  <li><strong>Pago anual:</strong> Descuento aplicado al precio anual completo</li>
                  <li><strong>Pago mensual:</strong> Descuento aplicado solo a la primera mensualidad</li>
                </ul>
              </li>
            </ol>
          </div>
        `;
        messageDiv.style.display = 'block';
      } else {
        messageDiv.style.display = 'none';
      }
    } else if (discountType === "fixed") {
      // ✅ Descuento fijo (siempre es <100%)
      messageDiv.innerHTML = `
        <div class="alert alert-info" role="alert">
          <strong>💰 Descuento de Campaña (Monto Fijo):</strong> 
          Con un descuento fijo de $${value}, los usuarios deberán:
          <ol style="margin-bottom: 0; padding-left: 20px;">
            <li>Completar formulario de registro</li>
            <li>Seleccionar plan y número de licencias en la página de Precios</li>
            <li>Ver comparación de precio normal vs precio con descuento</li>
            <li>Pagar el precio descontado:
              <ul style="margin-top: 5px; margin-bottom: 0;">
                <li><strong>Pago anual:</strong> Descuento aplicado al precio anual completo</li>
                <li><strong>Pago mensual:</strong> Descuento aplicado solo a la primera mensualidad</li>
              </ul>
            </li>
          </ol>
        </div>
      `;
      messageDiv.style.display = 'block';
    }
  };

  React.useEffect(() => {
    const tkn = window.sessionStorage.getItem("Token");
    const usr = window.sessionStorage.getItem("User");
    
    console.log("🔍 [useEffect] Token:", tkn ? "SÍ" : "NO");
    console.log("🔍 [useEffect] User:", usr ? "SÍ" : "NO");
    console.log("🔍 [useEffect] Token valor:", tkn);
    console.log("🔍 [useEffect] User valor:", usr);
    console.log("🔍 [useEffect] REACT_APP_BASEURL:", process.env.REACT_APP_BASEURL);
    console.log("🔍 [useEffect] URL completa:", url);
    console.log("🔍 [useEffect] ¿Es HTTPS?:", url.startsWith('https'));
    
    if (!tkn || !usr) {
      console.log("❌ [useEffect] Redirigiendo a login - Token o User faltante");
      history.push("/");
    } else {
      console.log("✅ [useEffect] Autenticación OK, cargando campañas");
      loadCampaigns();
    }
  }, []);

  // ✅ NUEVO: Agregar listener al cambiar tipo y valor de descuento
  React.useEffect(() => {
    const discountTypeSelect = document.getElementById("discount-type");
    const discountValueInput = document.getElementById("discount-value");
    
    if (discountTypeSelect && discountValueInput) {
      const handleTypeChange = () => {
        const value = discountValueInput.value;
        const type = discountTypeSelect.value;
        
        // Actualizar max para porcentajes
        if (type === "percentage") {
          discountValueInput.setAttribute("max", "100");
          discountValueInput.setAttribute("placeholder", "Ej: 20 o 100");
        } else {
          discountValueInput.removeAttribute("max");
          discountValueInput.setAttribute("placeholder", "Ej: 50");
        }
        
        // Actualizar mensaje
        updateDiscountMessage(value, type);
      };
      
      const handleValueChange = () => {
        const value = discountValueInput.value;
        const type = discountTypeSelect.value;
        updateDiscountMessage(value, type);
      };
      
      discountTypeSelect.addEventListener("change", handleTypeChange);
      discountValueInput.addEventListener("input", handleValueChange);
      discountValueInput.addEventListener("change", handleValueChange);
      
      // Limpiar listeners al desmontar
      return () => {
        discountTypeSelect.removeEventListener("change", handleTypeChange);
        discountValueInput.removeEventListener("input", handleValueChange);
        discountValueInput.removeEventListener("change", handleValueChange);
      };
    }
  }, []);

  const loadCampaigns = () => {
    // DEBUG: Verificar token antes de cargar campañas
    const token = window.sessionStorage.getItem("Token");
    console.log("🔍 [loadCampaigns] Token disponible:", token ? "SÍ" : "NO");
    console.log("🔍 [loadCampaigns] Token valor:", token);
    
    if (!token) {
      setSnackbar({
        open: true,
        message: t('campaigns.snackbar.noTokenError'),
        severity: "error",
      });
      return;
    }
    
    console.log("🚀 [loadCampaigns] Enviando petición a:", `${url}/api/coupon-campaign/list`);
    console.log("🚀 [loadCampaigns] Headers:", { "x-access-token": token });
    
    axios
      .get(`${url}/api/coupon-campaign/list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((res) => {
        console.log("🔍 [loadCampaigns] Respuesta completa:", res.data);
        console.log("🔍 [loadCampaigns] Tipo de datos:", typeof res.data);
        console.log("🔍 [loadCampaigns] Es array:", Array.isArray(res.data));
        console.log("🔍 [loadCampaigns] Longitud:", res.data?.length);
        console.log("🔍 [loadCampaigns] res.data.data:", res.data.data);
        console.log("🔍 [loadCampaigns] res.data.data es array:", Array.isArray(res.data.data));
        setCampaigns(res.data.data || []);
      })
      .catch((err) => {
        console.log(err, err.response);
        if (err?.response?.status === 401) {
          history.push("/");
          sessionStorage.clear();
        }
        setSnackbar({
          open: true,
          message: err?.response?.data?.message || t('campaigns.snackbar.loadError'),
          severity: "error",
        });
      });
  };

  const handleCreateCampaign = (e) => {
    e.preventDefault();
    
    // DEBUG: Verificar token antes de enviar
    const token = window.sessionStorage.getItem("Token");
    console.log("🔍 Token disponible:", token ? "SÍ" : "NO");
    console.log("🔍 Token valor:", token);
    
    if (!token) {
      setSnackbar({
        open: true,
        message: t('campaigns.snackbar.noTokenError'),
        severity: "error",
      });
      return;
    }
    
    const discountType = document.getElementById("discount-type").value;
    const discountValue = parseFloat(document.getElementById("discount-value").value);
    
    // ✅ NUEVO: Validación de descuento
    if (discountType === "percentage" && discountValue > 100) {
      setSnackbar({
        open: true,
        message: t('campaigns.snackbar.percentOverMax'),
        severity: "error",
      });
      return;
    }
    
    if (discountValue < 0) {
      setSnackbar({
        open: true,
        message: t('campaigns.snackbar.discountNegative'),
        severity: "error",
      });
      return;
    }
    
    // ✅ NUEVO: Confirmación si es 100% (trial gratis)
    if (discountType === "percentage" && discountValue === 100) {
      setConfirmDialog({
        open: true,
        title: t('campaigns.confirmTrial.title'),
        message: t('campaigns.confirmTrial.message'),
        onConfirm: () => {
          setConfirmDialog({ open: false, title: "", message: "", onConfirm: null });
          proceedWithCampaignCreation(discountType, discountValue, token);
        },
      });
      return;
    }
    
    proceedWithCampaignCreation(discountType, discountValue, token);
  };
  
  const proceedWithCampaignCreation = (discountType, discountValue, token) => {
    
    const formData = {
      campaignName: document.getElementById("campaign-name").value,
      description: document.getElementById("campaign-description").value,
      startDate: document.getElementById("campaign-start-date").value,
      endDate: document.getElementById("campaign-end-date").value,
      discountType: discountType,
      discountValue: discountValue,
      couponQuantity: document.getElementById("coupon-quantity").value,
      campaignCode: document.getElementById("coupon-prefix").value,
      status: document.getElementById("campaign-status").value,
      // ✅ Sin prueba => 0 días (campaña de solo descuento)
      trialDays: isNoTrialCampaign ? 0 : Number(trialDaysValue),
    };

    const endpoint = isEditing
      ? `${url}/api/coupon-campaign/update/${selectedCampaign.id}`
      : `${url}/api/coupon-campaign/create`;

    const method = isEditing ? axios.put : axios.post;

    console.log("🚀 Enviando petición a:", endpoint);
    console.log("🚀 Headers:", { "x-access-token": token });

    method(endpoint, formData, {
      headers: {
        "x-access-token": token,
      },
    })
      .then((res) => {
        setSnackbar({
          open: true,
          message: isEditing
            ? "Campaña actualizada exitosamente"
            : "Campaña creada exitosamente",
          severity: "success",
        });
        document.getElementById("close-campaign-modal").click();
        loadCampaigns();
        resetForm();
      })
      .catch((err) => {
        console.log(err);
        setSnackbar({
          open: true,
          message: err.response?.data?.message || "Error al guardar la campaña",
          severity: "error",
        });
      });
  };

  const handleDeleteCampaign = (campaignId) => {
    setConfirmDialog({
      open: true,
      title: t('campaigns.confirmDelete.title'),
      message: t('campaigns.confirmDelete.message'),
      onConfirm: () => {
        setConfirmDialog({ open: false, title: "", message: "", onConfirm: null });
        deleteCampaign(campaignId);
      },
    });
  };
  
  const deleteCampaign = (campaignId) => {
    axios
      .delete(`${url}/api/admin/delete-campaign/${campaignId}`, {
        headers: {
          "x-access-token": window.sessionStorage.getItem("Token"),
        },
      })
      .then((res) => {
        setSnackbar({
          open: true,
          message: t('campaigns.snackbar.deletedSuccess'),
          severity: "success",
        });
        loadCampaigns();
      })
      .catch((err) => {
        setSnackbar({
          open: true,
          message: err.response?.data?.message || t('campaigns.snackbar.deleteError'),
          severity: "error",
        });
      });
  };

  const handleEditCampaign = (campaign) => {
    setSelectedCampaign(campaign);
    setIsEditing(true);
    // Populate form with campaign data
    setTimeout(() => {
      document.getElementById("campaign-name").value = campaign.name;
      document.getElementById("campaign-description").value =
        campaign.description;
      document.getElementById("campaign-start-date").value = campaign.startDate
        ?.split("T")[0];
      document.getElementById("campaign-end-date").value = campaign.endDate
        ?.split("T")[0];
      document.getElementById("discount-type").value = campaign.discountType;
      document.getElementById("discount-value").value = campaign.discountValue;
      document.getElementById("coupon-quantity").value = campaign.couponQuantity;
      document.getElementById("coupon-prefix").value = campaign.couponPrefix || "";
      document.getElementById("campaign-status").value = campaign.status;
      // ✅ 0 es un valor válido (sin prueba), por eso no se usa ||
      const editingTrialDays = Number(campaign.trialDays ?? 14);
      setIsNoTrialCampaign(editingTrialDays === 0);
      setTrialDaysValue(editingTrialDays === 0 ? 14 : editingTrialDays);
      
      // ✅ NUEVO: Mostrar mensaje informativo al editar
      updateDiscountMessage(campaign.discountValue, campaign.discountType);
    }, 100);
  };

  const resetForm = () => {
    setSelectedCampaign(null);
    setIsEditing(false);
    setIsNoTrialCampaign(false);
    setTrialDaysValue(14);
    document.getElementById("campaign-form").reset();
  };


  const getCampaignStatusCode = (campaign) => {
    const now = new Date();
    const start = new Date(campaign.startDate);
    const end = new Date(campaign.endDate);

    if (campaign.status === "inactive") return "inactive";
    if (now < start) return "scheduled";
    if (now > end) return "finished";
    return "active";
  };

  return (
    <>
      <div className="mx-4 mt-58">

        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-center py-2">
          <h5 className="section-title">
            <Icon.Target size={32} className="mr-2 text-primary" />
            {t('campaigns.pageTitle')}
          </h5>
          <button
            className="btn btn-primary"
            data-toggle="modal"
            data-target="#campaignModal"
            onClick={resetForm}
          >
            <Icon.Plus size={18} className="mr-2" />
            {t('campaigns.newCampaign')}
          </button>
        </div>

        {/* Campaigns Grid */}
        <div className="row">
          {campaigns.length > 0 ? (
            campaigns.map((campaign, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-4">
                <div className="card campaign-card">
                  <div className="card-body">
                    <div className="mb-3">
                      <h5 className="card-title mb-0">{campaign.name}</h5>
                    </div>
                    <p className="card-text text-muted">
                      {campaign.description}
                    </p>

                    <div className="campaign-details">
                      <div className="detail-item">
                        <Icon.Calendar size={16} className="mr-2" />
                        <span>
                          {new Date(campaign.startDate).toLocaleDateString()} -{" "}
                          {new Date(campaign.endDate).toLocaleDateString()}
                        </span>
                      </div>
                      <div className="detail-item">
                        <Icon.Tag size={16} className="mr-2" />
                        <span>
                          {campaign.discountType === "percentage" ? (
                            parseFloat(campaign.discountValue || 0) === 100 ? (
                              <span>
                                <strong style={{ color: '#28a745' }}>{t('campaigns.grid.discount.trial')}</strong>
                                <small className="ml-2 text-muted">(100%)</small>
                              </span>
                            ) : (
                              <span>
                                {t('campaigns.grid.discount.percent', { value: parseFloat(campaign.discountValue || 0).toFixed(2) })}
                                <small className="ml-2 text-muted">{t('campaigns.grid.discountTag')}</small>
                              </span>
                            )
                          ) : (
                            <span>
                              {t('campaigns.grid.discount.fixed', { value: parseFloat(campaign.discountValue || 0).toFixed(2) })}
                              <small className="ml-2 text-muted">{t('campaigns.grid.discountTag')}</small>
                            </span>
                          )}
                        </span>
                      </div>
                      <div className="detail-item">
                        <Icon.ShoppingBag size={16} className="mr-2" />
                        <span>
                          {t('campaigns.grid.generated', { count: campaign.totalCoupons !== undefined ? campaign.totalCoupons : 0 })}
                        </span>
                      </div>
                      <div className="detail-item">
                        <Icon.Users size={16} className="mr-2" />
                        <span>
                          {t('campaigns.grid.assigned', { count: campaign.assignedCoupons !== undefined ? campaign.assignedCoupons : 0 })}
                        </span>
                      </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          data-toggle="modal"
                          data-target="#campaignModal"
                          onClick={() => handleEditCampaign(campaign)}
                        >
                          <Icon.Edit2 size={14} className="mr-1" />
                          {t('campaigns.grid.edit')}
                        </button>
                        <button
                          className="btn btn-sm btn-outline-info"
                          onClick={() =>
                            history.push(`/coupons?campaign=${campaign.campaignId || campaign.id}&campaignName=${encodeURIComponent(campaign.campaignName || campaign.name || '')}`)
                          }
                        >
                          <Icon.Eye size={14} className="mr-1" />
                          {t('campaigns.grid.viewCoupons')}
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDeleteCampaign(campaign.campaignId || campaign.id)}
                        >
                          <Icon.Trash2 size={14} />
                        </button>
                      </div>
                      <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                        <span
                          className={`badge badge-${
                            (function(){
                              const s = getCampaignStatusCode(campaign);
                              return s === 'active' ? 'success' : s === 'scheduled' ? 'info' : s === 'finished' ? 'secondary' : 'warning';
                            })()
                          }`}
                        >
                          {t(`campaigns.status.${getCampaignStatusCode(campaign)}`)}
                        </span>
                        <span className="badge badge-secondary" style={{ fontSize: '0.75rem' }}>
                          {campaign.campaignId || campaign.id}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="card">
                <div className="card-body text-center py-5">
                  <Icon.Inbox size={64} className="text-muted mb-3" />
                  <h5 className="text-muted">{t('campaigns.empty.title')}</h5>
                  <p className="text-muted">{t('campaigns.empty.subtitle')}</p>
                  <button
                    className="btn btn-primary mt-3"
                    data-toggle="modal"
                    data-target="#campaignModal"
                    onClick={resetForm}
                  >
                    <Icon.Plus size={18} className="mr-2" />
                    {t('campaigns.empty.createFirst')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Campaign Modal */}
        <div
          className="modal fade"
          id="campaignModal"
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? t('campaigns.modal.titleEdit') : t('campaigns.modal.titleCreate')}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  id="close-campaign-modal"
                  onClick={resetForm}
                >
                  <span>&times;</span>
                </button>
              </div>
              <form
                id="campaign-form"
                onSubmit={handleCreateCampaign}
                method="POST"
              >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12 form-group">
                      <label htmlFor="campaign-name">{t('campaigns.form.name')}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="campaign-name"
                        placeholder={t('campaigns.form.name')}
                        required
                      />
                    </div>
                    <div className="col-md-12 form-group">
                      <label htmlFor="campaign-description">{t('campaigns.form.description')}</label>
                      <textarea
                        className="form-control"
                        id="campaign-description"
                        rows="3"
                        placeholder={t('campaigns.form.description')}
                      ></textarea>
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="campaign-start-date">{t('campaigns.form.startDate')}</label>
                      <input
                        type="date"
                        className="form-control"
                        id="campaign-start-date"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="campaign-end-date">{t('campaigns.form.endDate')}</label>
                      <input
                        type="date"
                        className="form-control"
                        id="campaign-end-date"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="discount-type">{t('campaigns.form.discountType')}</label>
                      <select
                        className="form-control"
                        id="discount-type"
                        required
                      >
                        <option value="percentage">{t('campaigns.form.discountTypePercentage')}</option>
                        <option value="fixed">{t('campaigns.form.discountTypeFixed')}</option>
                      </select>
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="discount-value">{t('campaigns.form.discountValue')}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="discount-value"
                        placeholder="20"
                        min="0"
                        max="100"
                        step="0.01"
                        required
                      />
                      <small className="form-text text-muted">
                        {t('campaigns.form.discountHelp')}
                      </small>
                      
                      {/* ✅ NUEVO: Mensaje informativo dinámico */}
                      <div id="discount-info-message" className="mt-2" style={{ display: 'none' }}>
                        {/* Se actualizará dinámicamente con JavaScript */}
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="coupon-quantity">{t('campaigns.form.quantity')}</label>
                      <input
                        type="number"
                        className="form-control"
                        id="coupon-quantity"
                        placeholder="100"
                        min="1"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="coupon-prefix">{t('campaigns.form.prefix')}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="coupon-prefix"
                        placeholder="BACK2SCHOOL"
                        maxLength="20"
                      />
                      <small className="form-text text-muted">
                        {t('campaigns.form.prefixHelp')}
                      </small>
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="trial-days">{t('campaigns.form.trialDays')}</label>
                      <div className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="no-trial-campaign"
                          checked={isNoTrialCampaign}
                          onChange={(e) =>
                            setIsNoTrialCampaign(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="no-trial-campaign"
                        >
                          {t('campaigns.form.noTrial')}
                        </label>
                      </div>
                      <input
                        type="number"
                        className="form-control"
                        id="trial-days"
                        placeholder="14"
                        min={isNoTrialCampaign ? 0 : 14}
                        max="60"
                        value={isNoTrialCampaign ? 0 : trialDaysValue}
                        onChange={(e) => setTrialDaysValue(e.target.value)}
                        disabled={isNoTrialCampaign}
                        required={!isNoTrialCampaign}
                      />
                      {isNoTrialCampaign ? (
                        <div className="alert alert-warning py-2 px-2 mt-2 mb-0">
                          <strong>{t('campaigns.form.noTrialBadge')}</strong>
                          <div className="small mt-1">
                            {t('campaigns.form.noTrialHelp')}
                          </div>
                        </div>
                      ) : (
                        <small className="form-text text-muted">
                          {t('campaigns.form.trialDaysHelp')}
                        </small>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label htmlFor="campaign-status">{t('campaigns.form.status')}</label>
                      <select
                        className="form-control"
                        id="campaign-status"
                        required
                      >
                        <option value="active">{t('campaigns.form.statusActive')}</option>
                        <option value="inactive">{t('campaigns.form.statusInactive')}</option>
                      </select>
                    </div>
                  </div>
                  {!isEditing && (
                    <div className="alert alert-info mt-3" role="alert">
                      <Icon.Info size={18} className="mr-2" />
                      {t('campaigns.note')}
                    </div>
                  )}
                  <div className="row">
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={resetForm}
                  >
                    {t('campaigns.footer.cancel')}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <Icon.Save size={18} className="mr-2" />
                    {isEditing ? t('campaigns.footer.update') : t('campaigns.footer.create')} {t('campaigns.footer.campaign')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      {/* Dialog de Confirmación */}
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, title: "", message: "", onConfirm: null })}
        PaperProps={{
          sx: {
            backgroundColor: isDarkMode ? "#1e1e1e" : "#ffffff",
            color: isDarkMode ? "#e0e0e0" : "#1a1a1a",
          },
        }}
      >
        <DialogTitle sx={{ color: isDarkMode ? "#e0e0e0" : "#1a1a1a", display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon sx={{ color: "#ff9800" }} />
          {confirmDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: isDarkMode ? "#e0e0e0" : "#1a1a1a", whiteSpace: "pre-line" }}>
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: isDarkMode ? "#1e1e1e" : "#ffffff" }}>
          <Button
            onClick={() => setConfirmDialog({ open: false, title: "", message: "", onConfirm: null })}
            sx={{ color: isDarkMode ? "#e0e0e0" : "#1a1a1a" }}
          >
            {t('campaigns.dialog.cancel')}
          </Button>
          <Button
            onClick={() => {
              if (confirmDialog.onConfirm) {
                confirmDialog.onConfirm();
              }
            }}
            variant="contained"
            color="primary"
            autoFocus
          >
            {t('campaigns.dialog.accept')}
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Campaigns;
